<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          class="elevation-0"
          small
          tile
          color="light"
          style="background-color: #fff;"
          @click.stop="open = !open"
          v-bind="attrs"
          v-on="on"
          v-bind:disabled="disabled">
        <v-icon left> mdi-menu-down</v-icon>
        {{ $t('actions.actions') }}
      </v-btn>
    </template>
    <v-list v-model="open">
      <div v-for="(action, index) in actions" :key="index">
        <v-divider v-if="action.dividerBefore"/>
        <v-list-item
            :disabled="action.disabled"
            @click="action.click">
          <v-icon
              :disabled="action.disabled"
              v-if="action.icon"
              left>
            {{ action.icon }}
          </v-icon>
          {{ action.label }}
        </v-list-item>
        <v-divider v-if="action.dividerAfter"/>
      </div>
    </v-list>

  </v-menu>
</template>

<script>
/**
 * {
 *   icon:  mdi icon name like 'mdi-delete', optional
 *   label: label text , required
 *   click: function to call, required
 *   disabled: disables action, optional defaults to false
 *   dividerBefore: true|false. Add divider line before this action
 *   dividerAfter: true|false. Add divider line after this action
 * }
 */
import Vue from 'vue';

export default Vue.extend({
  name: 'EntityTableSelectedRowsActionMenu',
  data: () => ({
    open: false,
  }),
  props: {
    actions: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
});
</script>
